module.exports = __webpack_public_path__ + "static/media/view.ab05868f.svg";